module.exports = __webpack_public_path__ + "img/数据中心-2.3f726ba6.png";